export const teamsDB = [
  {
    id: 1,
    name: '苏州KSG',
    fullName: 'KuGou Esports Club',
    shortName: 'KSG',
    city: '苏州',
    stadium: '苏州阳澄国际电竞馆',
    logo: 'https://img.kpl.cn/teamlogo/ksg.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/ksg_logo.png',
    color: '#8B5CF6',
    secondaryColor: '#A78BFA',
    foundedYear: 2018,
    coach: '子旗（万子旗）',
    isChampion: true,
    championship: '2026年KPL春季赛总冠军（队史首冠）',
    achievements: ['2026年KPL春季赛冠军', '2025年挑战者杯亚军'],
    group: '第1组（种子队）',
    springRank: 1,
    stats: { wins: 14, losses: 2, winRate: 87.5, points: 42 },
    roster: [
      { id: 101, name: '无言', realName: '赵昊宇', position: '对抗路', role: 'Top', avatar: '', heroPool: ['孙策', '蒙恬', '狂铁', '姬小满', '司空震'], kd: 4.2, mvpCount: 5, gamesPlayed: 16, signatureHero: '孙策' },
      { id: 102, name: '句号', realName: '何伟嘉', position: '打野', role: 'Jungle', avatar: '', heroPool: ['镜', '澜', '裴擒虎', '孙悟空', '百里玄策'], kd: 5.8, mvpCount: 9, gamesPlayed: 16, signatureHero: '镜' },
      { id: 103, name: '流浪', realName: '张恒', position: '中路', role: 'Mid', avatar: '', heroPool: ['不知火舞', '西施', '弈星', '海月', '王昭君'], kd: 5.2, mvpCount: 12, gamesPlayed: 16, signatureHero: '不知火舞', isFMVP: true, fmvpTournament: '2026年KPL春季赛总决赛' },
      { id: 104, name: '小屿', realName: '王思琪', position: '发育路', role: 'ADC', avatar: '', heroPool: ['公孙离', '戈娅', '狄仁杰', '鲁班七号', '后羿'], kd: 6.2, mvpCount: 10, gamesPlayed: 16, signatureHero: '公孙离' },
      { id: 105, name: '一笙', realName: '李自威', position: '游走', role: 'Support', avatar: '', heroPool: ['大乔', '朵莉亚', '少司缘', '张飞', '墨子'], kd: 3.8, mvpCount: 4, gamesPlayed: 16, signatureHero: '大乔' }
    ],
    substitutes: [
      { id: 106, name: '流星', realName: '李星', position: '对抗路', role: 'Top' },
      { id: 107, name: '风萧', realName: '于翔任', position: '发育路', role: 'ADC' },
      { id: 108, name: '子阳', realName: '向阳', position: '游走', role: 'Support' }
    ],
    description: '苏州KSG，2026年KPL春季赛总冠军！以"逆锋破阵，乘梦追光"为信念，从败者组一穿四创造奇迹，夺得队史首座银龙杯！'
  },
  {
    id: 2,
    name: '重庆狼队',
    fullName: 'Wolf Esports Club',
    shortName: '狼队',
    city: '重庆',
    stadium: '重庆巴南区体育中心',
    logo: 'https://img.kpl.cn/teamlogo/wolves.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/wolves_logo.png',
    color: '#FFD700',
    secondaryColor: '#FFA500',
    foundedYear: 2016,
    coach: 'SK（宋季泽）',
    isChampion: false,
    championship: '',
    achievements: ['2025年挑战者杯冠军', '2023年KPL夏季赛冠军', '10次KPL总冠军（历史最多）'],
    group: '第5组（种子队）',
    springRank: 2,
    stats: { wins: 13, losses: 3, winRate: 81.25, points: 39 },
    roster: [
      { id: 201, name: '清清', realName: '吴金翔', position: '对抗路', role: 'Top', avatar: '', heroPool: ['马超', '关羽', '元歌', '花木兰', '司空震'], kd: 4.5, mvpCount: 7, gamesPlayed: 16, signatureHero: '马超' },
      { id: 202, name: '皖皖', realName: '杜远航', position: '打野', role: 'Jungle', avatar: '', heroPool: ['镜', '澜', '大司命', '裴擒虎', '孙悟空'], kd: 5.1, mvpCount: 8, gamesPlayed: 16, signatureHero: '镜' },
      { id: 203, name: '紫幻', realName: '黄广顺', position: '中路', role: 'Mid', avatar: '', heroPool: ['不知火舞', '安琪拉', '上官婉儿', '海诺', '弈星'], kd: 4.8, mvpCount: 6, gamesPlayed: 16, signatureHero: '不知火舞' },
      { id: 204, name: '道崽', realName: '杨凯博', position: '发育路', role: 'ADC', avatar: '', heroPool: ['戈娅', '公孙离', '后羿', '狄仁杰', '鲁班七号'], kd: 5.9, mvpCount: 11, gamesPlayed: 16, signatureHero: '戈娅' },
      { id: 205, name: '信', realName: '苟宏鑫', position: '游走', role: 'Support', avatar: '', heroPool: ['朵莉亚', '少司缘', '大乔', '张飞', '苏烈'], kd: 3.5, mvpCount: 3, gamesPlayed: 16, signatureHero: '朵莉亚' }
    ],
    substitutes: [
      { id: 206, name: '归期', realName: '双小钧', position: '对抗路', role: 'Top' },
      { id: 207, name: '小胖', realName: '李达亨', position: '打野', role: 'Jungle' },
      { id: 208, name: '晚星', realName: '王恒鸿', position: '中路', role: 'Mid' }
    ],
    description: '重庆狼队，KPL历史上最成功的战队之一，拥有10次总冠军纪录。2026年春季赛获得亚军，冲击第十一冠！'
  },
  {
    id: 3,
    name: '成都AG超玩会',
    fullName: 'All Gamers Super Play Club',
    shortName: 'AG',
    city: '成都',
    stadium: '成都量子光中心',
    logo: 'https://img.kpl.cn/teamlogo/ag.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/ag_logo.png',
    color: '#FF6B00',
    secondaryColor: '#FF8C00',
    foundedYear: 2016,
    coach: 'Bao（常琦）',
    isChampion: false,
    championship: '',
    achievements: ['2025年KPL年度总决赛冠军（六连冠）', '2025年KPL夏季赛冠军'],
    group: '第3组',
    springRank: 3,
    stats: { wins: 12, losses: 4, winRate: 75, points: 36 },
    roster: [
      { id: 301, name: '一诺', realName: '徐必成', position: '发育路', role: 'ADC', avatar: '', heroPool: ['后羿', '戈娅', '鲁班七号', '公孙离', '狄仁杰'], kd: 5.6, mvpCount: 14, gamesPlayed: 16, signatureHero: '后羿', isFMVP: true, fmvpTournament: '2025年KPL年度总决赛' },
      { id: 302, name: '轩染', realName: '刘明', position: '对抗路', role: 'Top', avatar: '', heroPool: ['蒙恬', '狂铁', '姬小满', '司空震', '孙策'], kd: 4.0, mvpCount: 5, gamesPlayed: 16, signatureHero: '蒙恬' },
      { id: 303, name: '长生', realName: '谢承峻', position: '中路', role: 'Mid', avatar: '', heroPool: ['不知火舞', '西施', '安琪拉', '海月', '弈星'], kd: 4.6, mvpCount: 7, gamesPlayed: 16, signatureHero: '西施' },
      { id: 304, name: '钟意', realName: '陈家豪', position: '打野', role: 'Jungle', avatar: '', heroPool: ['大司命', '镜', '澜', '裴擒虎', '孙悟空'], kd: 4.9, mvpCount: 8, gamesPlayed: 16, signatureHero: '大司命' },
      { id: 305, name: '大帅', realName: '孟家俊', position: '游走', role: 'Support', avatar: '', heroPool: ['少司缘', '朵莉亚', '大乔', '张飞', '鬼谷子'], kd: 3.6, mvpCount: 6, gamesPlayed: 16, signatureHero: '少司缘', isFMVP: true, fmvpTournament: '2025年KPL夏季赛' }
    ],
    substitutes: [
      { id: 306, name: '北诗', realName: '郑国浩', position: '发育路', role: 'ADC' },
      { id: 307, name: '小俞', realName: '周宇', position: '打野', role: 'Jungle' },
      { id: 308, name: '救赎', realName: '张佳豪', position: '游走', role: 'Support' }
    ],
    description: '成都AG超玩会，KPL传奇战队！达成历史首个六连冠伟业，拥有8座总冠军奖杯。一诺作为标志性选手，多次斩获FMVP荣誉！'
  },
  {
    id: 4,
    name: '广州TTG',
    fullName: 'Talent Gaming',
    shortName: 'TTG',
    city: '广州',
    stadium: '广州天河文化艺术中心',
    logo: 'https://img.kpl.cn/teamlogo/ttg.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/ttg_logo.png',
    color: '#FF4444',
    secondaryColor: '#FF6666',
    foundedYear: 2016,
    coach: '久哲（胡庄浩）',
    isChampion: false,
    championship: '',
    achievements: ['2023年KPL夏季赛冠军', '2025年王者荣耀电竞世界杯亚军'],
    group: '第1组',
    springRank: 4,
    stats: { wins: 11, losses: 5, winRate: 68.75, points: 33 },
    roster: [
      { id: 401, name: '帆帆', realName: '杨廷普', position: '游走', role: 'Support', avatar: '', heroPool: ['张飞', '牛魔', '苏烈', '少司缘', '大乔'], kd: 3.2, mvpCount: 4, gamesPlayed: 16, signatureHero: '张飞' },
      { id: 402, name: '清清', realName: '吴金翔', position: '对抗路', role: 'Top', avatar: '', heroPool: ['马超', '关羽', '花木兰', '元歌', '司空震'], kd: 4.3, mvpCount: 6, gamesPlayed: 16, signatureHero: '马超' },
      { id: 403, name: '九尾', realName: '许鑫蓁', position: '中路', role: 'Mid', avatar: '', heroPool: ['不知火舞', '上官婉儿', '西施', '安琪拉', '弈星'], kd: 4.7, mvpCount: 8, gamesPlayed: 16, signatureHero: '不知火舞' },
      { id: 404, name: '钎城', realName: '周诣涛', position: '发育路', role: 'ADC', avatar: '', heroPool: ['戈娅', '公孙离', '后羿', '狄仁杰', '鲁班七号'], kd: 5.4, mvpCount: 9, gamesPlayed: 16, signatureHero: '戈娅' },
      { id: 405, name: '小白', realName: '', position: '打野', role: 'Jungle', avatar: '', heroPool: ['镜', '澜', '裴擒虎', '大司命', '孙悟空'], kd: 4.5, mvpCount: 5, gamesPlayed: 16, signatureHero: '镜' }
    ],
    substitutes: [],
    description: '广州TTG，前身为XQ战队，2020年正式更名。曾获2023年KPL夏季赛冠军，是广州地区唯一KPL战队！'
  },
  {
    id: 5,
    name: '武汉eStarPro',
    fullName: 'eStar Professional',
    shortName: 'eS',
    city: '武汉',
    stadium: '武汉客厅中国文化博览中心',
    logo: 'https://img.kpl.cn/teamlogo/estar.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/estar_logo.png',
    color: '#FFD700',
    secondaryColor: '#FFE066',
    foundedYear: 2016,
    coach: '笑风（熊云鹏）',
    isChampion: false,
    championship: '',
    achievements: ['多届KPL总冠军', 'Fly为联盟标志性选手'],
    group: '第2组',
    springRank: 5,
    stats: { wins: 11, losses: 5, winRate: 68.75, points: 33 },
    roster: [
      { id: 501, name: 'Fly', realName: '彭云飞', position: '对抗路', role: 'Top', avatar: '', heroPool: ['马超', '关羽', '花木兰', '元歌', '孙策'], kd: 4.1, mvpCount: 7, gamesPlayed: 16, signatureHero: '马超', isLegend: true, legendTitle: '七届总冠军选手' },
      { id: 502, name: '誓约', realName: '姚嘉鹏', position: '发育路', role: 'ADC', avatar: '', heroPool: ['公孙离', '戈娅', '后羿', '狄仁杰', '鲁班七号'], kd: 5.2, mvpCount: 8, gamesPlayed: 16, signatureHero: '公孙离' },
      { id: 503, name: '浅风', realName: '胡宸语', position: '打野', role: 'Jungle', avatar: '', heroPool: ['镜', '澜', '裴擒虎', '大司命', '孙悟空'], kd: 4.6, mvpCount: 6, gamesPlayed: 16, signatureHero: '镜' },
      { id: 504, name: '小楼', realName: '沈宇轩', position: '中路', role: 'Mid', avatar: '', heroPool: ['不知火舞', '西施', '安琪拉', '海月', '弈星'], kd: 4.4, mvpCount: 5, gamesPlayed: 16, signatureHero: '不知火舞' },
      { id: 505, name: 'Ming', realName: '池晓铭', position: '游走', role: 'Support', avatar: '', heroPool: ['朵莉亚', '少司缘', '大乔', '张飞', '鬼谷子'], kd: 3.3, mvpCount: 3, gamesPlayed: 16, signatureHero: '朵莉亚' }
    ],
    substitutes: [],
    description: '武汉eStarPro，KPL老牌豪门战队！Fly作为联盟传奇选手，共获得7次总冠军，是KPL历史上最具影响力的选手之一！'
  },
  {
    id: 6,
    name: '北京WB',
    fullName: 'Weibo Gaming',
    shortName: 'WB',
    city: '北京',
    stadium: '北京华熙LIVE五棵松',
    logo: 'https://img.kpl.cn/teamlogo/wb.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/wb_logo.png',
    color: '#FF4500',
    secondaryColor: '#FF6347',
    foundedYear: 2017,
    coach: '贝克曼',
    isChampion: false,
    championship: '',
    achievements: ['2022年KPL挑战者杯冠军'],
    group: '第2组',
    springRank: 6,
    stats: { wins: 10, losses: 6, winRate: 62.5, points: 30 },
    roster: [
      { id: 601, name: '暖阳', realName: '', position: '打野', role: 'Jungle', avatar: '', heroPool: ['镜', '澜', '裴擒虎', '大司命', '孙悟空'], kd: 4.8, mvpCount: 9, gamesPlayed: 16, signatureHero: '镜' },
      { id: 602, name: '乔离', realName: '', position: '发育路', role: 'ADC', avatar: '', heroPool: ['戈娅', '公孙离', '后羿', '狄仁杰', '鲁班七号'], kd: 5.1, mvpCount: 7, gamesPlayed: 16, signatureHero: '戈娅' },
      { id: 603, name: '梓墨', realName: '', position: '对抗路', role: 'Top', avatar: '', heroPool: ['蒙恬', '狂铁', '姬小满', '司空震', '孙策'], kd: 3.9, mvpCount: 4, gamesPlayed: 16, signatureHero: '蒙恬' },
      { id: 604, name: '妖刀', realName: '', position: '发育路', role: 'ADC', avatar: '', heroPool: ['公孙离', '戈娅', '后羿', '狄仁杰', '鲁班七号'], kd: 5.0, mvpCount: 6, gamesPlayed: 16, signatureHero: '公孙离' },
      { id: 605, name: '星宇', realName: '', position: '游走', role: 'Support', avatar: '', heroPool: ['朵莉亚', '少司缘', '大乔', '张飞', '鬼谷子'], kd: 3.4, mvpCount: 3, gamesPlayed: 16, signatureHero: '朵莉亚' }
    ],
    substitutes: [],
    description: '北京WB，前身为TS战队，以稳健的打法著称。曾获2022年KPL挑战者杯冠军！'
  },
  {
    id: 7,
    name: '佛山DRG',
    fullName: 'Dragon Ranger Gaming',
    shortName: 'DRG',
    city: '佛山',
    stadium: '佛山国际体育文化演艺中心',
    logo: 'https://img.kpl.cn/teamlogo/drg.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/drg_logo.png',
    color: '#00D4FF',
    secondaryColor: '#66E0FF',
    foundedYear: 2019,
    coach: '择（陈天择）',
    isChampion: false,
    championship: '',
    achievements: ['2022年KPL挑战者杯亚军'],
    group: '第1组',
    springRank: 7,
    stats: { wins: 10, losses: 6, winRate: 62.5, points: 30 },
    roster: [
      { id: 701, name: '梦岚', realName: '彭俊岚', position: '发育路', role: 'ADC', avatar: '', heroPool: ['公孙离', '戈娅', '后羿', '狄仁杰', '鲁班七号'], kd: 5.3, mvpCount: 8, gamesPlayed: 16, signatureHero: '公孙离' },
      { id: 702, name: '花缘', realName: '谭锦威', position: '对抗路', role: 'Top', avatar: '', heroPool: ['蒙恬', '狂铁', '姬小满', '司空震', '孙策'], kd: 4.0, mvpCount: 5, gamesPlayed: 16, signatureHero: '蒙恬' },
      { id: 703, name: '小小阳', realName: '应恒阳', position: '中路', role: 'Mid', avatar: '', heroPool: ['不知火舞', '西施', '安琪拉', '海月', '弈星'], kd: 4.5, mvpCount: 6, gamesPlayed: 16, signatureHero: '西施' },
      { id: 704, name: '柚子', realName: '袁树鑫', position: '打野', role: 'Jungle', avatar: '', heroPool: ['镜', '澜', '裴擒虎', '大司命', '孙悟空'], kd: 4.4, mvpCount: 5, gamesPlayed: 16, signatureHero: '镜' },
      { id: 705, name: '呆呆', realName: '赖永睿', position: '游走', role: 'Support', avatar: '', heroPool: ['朵莉亚', '少司缘', '大乔', '张飞', '鬼谷子'], kd: 3.3, mvpCount: 3, gamesPlayed: 16, signatureHero: '朵莉亚' }
    ],
    substitutes: [],
    description: '佛山DRG，前身为GK电子竞技俱乐部，以凶猛的进攻风格著称！'
  },
  {
    id: 8,
    name: '深圳DYG',
    fullName: 'DYG Esports Club',
    shortName: 'DYG',
    city: '深圳',
    stadium: '深圳南山文体中心',
    logo: 'https://img.kpl.cn/teamlogo/dyg.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/dyg_logo.png',
    color: '#00CED1',
    secondaryColor: '#40E0D0',
    foundedYear: 2019,
    coach: '点点（吴亮）',
    isChampion: false,
    championship: '',
    achievements: ['2020年KPL春季赛冠军'],
    group: '第7组',
    springRank: 8,
    stats: { wins: 9, losses: 7, winRate: 56.25, points: 27 },
    roster: [
      { id: 801, name: '钎城', realName: '周诣涛', position: '发育路', role: 'ADC', avatar: '', heroPool: ['戈娅', '公孙离', '后羿', '狄仁杰', '鲁班七号'], kd: 5.5, mvpCount: 10, gamesPlayed: 16, signatureHero: '戈娅' },
      { id: 802, name: '小乐', realName: '黄家乐', position: '对抗路', role: 'Top', avatar: '', heroPool: ['马超', '关羽', '花木兰', '元歌', '司空震'], kd: 4.2, mvpCount: 6, gamesPlayed: 16, signatureHero: '马超' },
      { id: 803, name: '小轩', realName: '王胜', position: '中路', role: 'Mid', avatar: '', heroPool: ['不知火舞', '西施', '安琪拉', '海月', '弈星'], kd: 4.6, mvpCount: 7, gamesPlayed: 16, signatureHero: '不知火舞' },
      { id: 804, name: '向鱼', realName: '蔡佑其', position: '打野', role: 'Jungle', avatar: '', heroPool: ['镜', '澜', '裴擒虎', '大司命', '孙悟空'], kd: 4.7, mvpCount: 6, gamesPlayed: 16, signatureHero: '镜' },
      { id: 805, name: '落空', realName: '周熙瑞', position: '游走', role: 'Support', avatar: '', heroPool: ['朵莉亚', '少司缘', '大乔', '张飞', '鬼谷子'], kd: 3.5, mvpCount: 4, gamesPlayed: 16, signatureHero: '朵莉亚' }
    ],
    substitutes: [],
    description: '深圳DYG，前身为JC战队，曾获2020年KPL春季赛冠军！'
  },
  {
    id: 9,
    name: '长沙TES.A',
    fullName: 'Top Esports Armored',
    shortName: 'TES',
    city: '长沙',
    stadium: '长沙梅溪湖国际文化艺术中心',
    logo: 'https://img.kpl.cn/teamlogo/tes.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/tes_logo.png',
    color: '#20B2AA',
    secondaryColor: '#48D1CC',
    foundedYear: 2019,
    coach: '',
    isChampion: false,
    championship: '',
    achievements: [],
    group: '第8组',
    springRank: 9,
    stats: { wins: 9, losses: 7, winRate: 56.25, points: 27 },
    roster: [],
    substitutes: [],
    description: '长沙TES.A，滔搏电竞旗下王者荣耀分部，年轻有活力的战队！'
  },
  {
    id: 10,
    name: '上海EDG.M',
    fullName: 'EDward Gaming Mobile',
    shortName: 'EDG.M',
    city: '上海',
    stadium: '上海虹桥天地演艺中心',
    logo: 'https://img.kpl.cn/teamlogo/edgm.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/edgm_logo.png',
    color: '#DC143C',
    secondaryColor: '#FF4444',
    foundedYear: 2017,
    coach: '白书（白清炎）',
    isChampion: false,
    championship: '',
    achievements: [],
    group: '第6组',
    springRank: 10,
    stats: { wins: 8, losses: 8, winRate: 50, points: 24 },
    roster: [],
    substitutes: [],
    description: '上海EDG.M，EDG俱乐部王者荣耀分部，传承EDG的电竞精神！'
  },
  {
    id: 11,
    name: '西安WE',
    fullName: 'WeFun Esports',
    shortName: 'WE',
    city: '西安',
    stadium: '西安曲江国际会议中心',
    logo: 'https://img.kpl.cn/teamlogo/we.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/we_logo.png',
    color: '#FF69B4',
    secondaryColor: '#FFB6C1',
    foundedYear: 2018,
    coach: '',
    isChampion: false,
    championship: '',
    achievements: [],
    group: '第7组',
    springRank: 11,
    stats: { wins: 8, losses: 8, winRate: 50, points: 24 },
    roster: [],
    substitutes: [],
    description: '西安WE，前身为WF.D战队，西北地区唯一KPL战队！'
  },
  {
    id: 12,
    name: '杭州LGD.NBW',
    fullNme: 'LGD New Big World',
    shortName: 'LGD',
    city: '杭州',
    stadium: '杭州LGD电竞中心',
    logo: 'https://img.kpl.cn/teamlogo/lgd.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/lgd_logo.png',
    color: '#9370DB',
    secondaryColor: '#BA55D3',
    foundedYear: 2020,
    coach: '漠然（张家立）',
    isChampion: false,
    championship: '',
    achievements: [],
    group: '第4组',
    springRank: 12,
    stats: { wins: 7, losses: 9, winRate: 43.75, points: 21 },
    roster: [
      { id: 1201, name: '九尾', realName: '许鑫蓁', position: '中路', role: 'Mid', avatar: '', heroPool: ['不知火舞', '上官婉儿', '西施', '安琪拉', '弈星'], kd: 4.8, mvpCount: 9, gamesPlayed: 16, signatureHero: '不知火舞' },
      { id: 1202, name: '小涵', realName: '钟志涵', position: '对抗路', role: 'Top', avatar: '', heroPool: ['蒙恬', '狂铁', '姬小满', '司空震', '孙策'], kd: 3.8, mvpCount: 4, gamesPlayed: 16, signatureHero: '蒙恬' },
      { id: 1203, name: '小落', realName: '王科', position: '打野', role: 'Jungle', avatar: '', heroPool: ['镜', '澜', '裴擒虎', '大司命', '孙悟空'], kd: 4.3, mvpCount: 5, gamesPlayed: 16, signatureHero: '镜' },
      { id: 1204, name: '小久', realName: '阳文明', position: '发育路', role: 'ADC', avatar: '', heroPool: ['戈娅', '公孙离', '后羿', '狄仁杰', '鲁班七号'], kd: 4.9, mvpCount: 6, gamesPlayed: 16, signatureHero: '戈娅' },
      { id: 1205, name: '冰尘', realName: '李小龙', position: '游走', role: 'Support', avatar: '', heroPool: ['朵莉亚', '少司缘', '大乔', '张飞', '鬼谷子'], kd: 3.4, mvpCount: 3, gamesPlayed: 16, signatureHero: '朵莉亚' }
    ],
    substitutes: [],
    description: '杭州LGD.NBW，LGD俱乐部与大鹅文化联合运营的KPL战队！'
  },
  {
    id: 13,
    name: '济南RW侠',
    fullName: 'Rogue Warriors',
    shortName: 'RW',
    city: '济南',
    stadium: '济南融创国际体育中心',
    logo: 'https://img.kpl.cn/teamlogo/rw.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/rw_logo.png',
    color: '#FFA500',
    secondaryColor: '#FFB84D',
    foundedYear: 2018,
    coach: '胖胖（谭斌）',
    isChampion: false,
    championship: '',
    achievements: [],
    group: '第3组',
    springRank: 13,
    stats: { wins: 7, losses: 9, winRate: 43.75, points: 21 },
    roster: [
      { id: 1301, name: '今屿', realName: '徐翔宇', position: '发育路', role: 'ADC', avatar: '', heroPool: ['公孙离', '戈娅', '后羿', '狄仁杰', '鲁班七号'], kd: 5.4, mvpCount: 8, gamesPlayed: 16, signatureHero: '公孙离' },
      { id: 1302, name: '梦溪', realName: '李文宝', position: '对抗路', role: 'Top', avatar: '', heroPool: ['蒙恬', '狂铁', '姬小满', '司空震', '孙策'], kd: 3.9, mvpCount: 4, gamesPlayed: 16, signatureHero: '蒙恬' },
      { id: 1303, name: '小度', realName: '古伟雄', position: '中路', role: 'Mid', avatar: '', heroPool: ['不知火舞', '西施', '安琪拉', '海月', '弈星'], kd: 4.3, mvpCount: 5, gamesPlayed: 16, signatureHero: '西施' },
      { id: 1304, name: '初晨', realName: '陶传凯', position: '打野', role: 'Jungle', avatar: '', heroPool: ['镜', '澜', '裴擒虎', '大司命', '孙悟空'], kd: 4.5, mvpCount: 6, gamesPlayed: 16, signatureHero: '镜' },
      { id: 1305, name: '挽墨', realName: '骆雪岩', position: '游走', role: 'Support', avatar: '', heroPool: ['朵莉亚', '少司缘', '大乔', '张飞', '鬼谷子'], kd: 3.3, mvpCount: 3, gamesPlayed: 16, signatureHero: '朵莉亚' }
    ],
    substitutes: [],
    description: '济南RW侠，前身为RW侠战队，以稳健著称的老牌战队！'
  },
  {
    id: 14,
    name: '北京JDG',
    fullName: 'JD Gaming',
    shortName: 'JDG',
    city: '北京',
    stadium: '北京京东总部电竞馆',
    logo: 'https://img.kpl.cn/teamlogo/jdg.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/jdg_logo.png',
    color: '#0000CD',
    secondaryColor: '#4169E1',
    foundedYear: 2022,
    coach: '行天（孙翔）',
    isChampion: false,
    championship: '',
    achievements: [],
    group: '第7组',
    springRank: 14,
    stats: { wins: 7, losses: 9, winRate: 43.75, points: 21 },
    roster: [
      { id: 1401, name: '无畏', realName: '杨涛', position: '对抗路', role: 'Top', avatar: '', heroPool: ['蒙恬', '狂铁', '姬小满', '司空震', '孙策'], kd: 4.1, mvpCount: 6, gamesPlayed: 16, signatureHero: '蒙恬', isMVP: true, mvpTitle: '2026KPL春季赛常规赛最佳选手' },
      { id: 1402, name: '清融', realName: '黄垚钦', position: '中路', role: 'Mid', avatar: '', heroPool: ['不知火舞', '西施', '安琪拉', '海月', '弈星'], kd: 4.9, mvpCount: 10, gamesPlayed: 16, signatureHero: '不知火舞', isFMVP: true, fmvpTournament: '2022年KPL春季赛总决赛' },
      { id: 1403, name: '绝意', realName: '廖友侠', position: '发育路', role: 'ADC', avatar: '', heroPool: ['戈娅', '公孙离', '后羿', '狄仁杰', '鲁班七号'], kd: 5.0, mvpCount: 7, gamesPlayed: 16, signatureHero: '戈娅' },
      { id: 1404, name: '轻语', realName: '谢欣臻', position: '打野', role: 'Jungle', avatar: '', heroPool: ['镜', '澜', '裴擒虎', '大司命', '孙悟空'], kd: 4.4, mvpCount: 5, gamesPlayed: 16, signatureHero: '镜' },
      { id: 1405, name: '无双', realName: '胡家荣', position: '游走', role: 'Support', avatar: '', heroPool: ['朵莉亚', '少司缘', '大乔', '张飞', '鬼谷子'], kd: 3.4, mvpCount: 4, gamesPlayed: 16, signatureHero: '朵莉亚' }
    ],
    substitutes: [],
    description: '北京JDG，京东旗下KPL战队！无畏获得2026春季赛常规赛最佳选手，清融曾获FMVP荣誉！'
  },
  {
    id: 15,
    name: '上海RNG.M',
    fullName: 'RNG Mobile',
    shortName: 'RNG.M',
    city: '上海',
    stadium: '上海RNG电竞中心',
    logo: 'https://img.kpl.cn/teamlogo/rngm.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/rngm_logo.png',
    color: '#FF1493',
    secondaryColor: '#FF69B4',
    foundedYear: 2018,
    coach: '久哲（胡庄浩）',
    isChampion: false,
    championship: '',
    achievements: [],
    group: '第8组',
    springRank: 15,
    stats: { wins: 6, losses: 10, winRate: 37.5, points: 18 },
    roster: [],
    substitutes: [],
    description: '上海RNG.M，RNG俱乐部王者荣耀分部！'
  },
  {
    id: 16,
    name: '南通Hero久竞',
    fullName: 'Hero Jiu Jing',
    shortName: 'Hero',
    city: '南通',
    stadium: '南通体育会展中心',
    logo: 'https://img.kpl.cn/teamlogo/hero.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/hero_logo.png',
    color: '#32CD32',
    secondaryColor: '#90EE90',
    foundedYear: 2018,
    coach: '爱思（唐田）',
    isChampion: false,
    championship: '',
    achievements: ['2018-2019三连冠'],
    group: '第5组',
    springRank: 16,
    stats: { wins: 5, losses: 11, winRate: 31.25, points: 15 },
    roster: [
      { id: 1601, name: '坦然', realName: '孙麟威', position: '对抗路', role: 'Top', avatar: '', heroPool: ['蒙恬', '狂铁', '姬小少', '司空震', '孙策'], kd: 3.8, mvpCount: 5, gamesPlayed: 16, signatureHero: '蒙恬', isFMVP: true, fmvpTournament: '2022年KPL秋季赛总决赛' },
      { id: 1602, name: '妖刀', realName: '钟乐天', position: '发育路', role: 'ADC', avatar: '', heroPool: ['戈娅', '公孙离', '后羿', '狄仁杰', '鲁班七号'], kd: 4.8, mvpCount: 7, gamesPlayed: 16, signatureHero: '戈娅' },
      { id: 1603, name: '落尘', realName: '张世杰', position: '打野', role: 'Jungle', avatar: '', heroPool: ['镜', '澜', '裴擒虎', '大司命', '孙悟空'], kd: 4.2, mvpCount: 4, gamesPlayed: 16, signatureHero: '镜' },
      { id: 1604, name: 'Silver', realName: '黄本帅', position: '中路', role: 'Mid', avatar: '', heroPool: ['不知火舞', '西施', '安琪拉', '海月', '弈星'], kd: 4.4, mvpCount: 6, gamesPlayed: 16, signatureHero: '西施' },
      { id: 1605, name: '玖熙', realName: '敖语思涵', position: '游走', role: 'Support', avatar: '', heroPool: ['朵莉亚', '少司缘', '大乔', '张飞', '鬼谷子'], kd: 3.2, mvpCount: 3, gamesPlayed: 16, signatureHero: '朵莉亚' }
    ],
    substitutes: [],
    description: '南通Hero久竞，曾经的王朝战队！2018-2019年实现三连冠伟业！'
  },
  {
    id: 17,
    name: '无锡TCG',
    fullName: 'TC Gaming',
    shortName: 'TCG',
    city: '无锡',
    stadium: '无锡太湖国际博览中心',
    logo: 'https://img.kpl.cn/teamlogo/tcg.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/tcg_logo.png',
    color: '#9370DB',
    secondaryColor: '#BA55D3',
    foundedYear: 2024,
    coach: '阿改（杨廷普）',
    isChampion: false,
    championship: '',
    achievements: [],
    group: '第2组',
    springRank: 17,
    stats: { wins: 4, losses: 12, winRate: 25, points: 12 },
    roster: [],
    substitutes: [],
    description: '无锡TCG，新晋KPL战队，充满潜力！'
  },
  {
    id: 18,
    name: '桐乡情久',
    fullName: 'Qing Jiu Esports',
    shortName: '情久',
    city: '桐乡',
    stadium: '桐乡市体育馆',
    logo: 'https://img.kpl.cn/teamlogo/qj.png',
    logoUrl: 'https://ossweb-img.qq.com/images/kpl/2024/teams/qj_logo.png',
    color: '#FF69B4',
    secondaryColor: '#FFB6C1',
    foundedYear: 2023,
    coach: '刘多鱼（刘涛）',
    isChampion: false,
    championship: '',
    achievements: [],
    group: '第8组',
    springRank: 18,
    stats: { wins: 3, losses: 13, winRate: 18.75, points: 9 },
    roster: [],
    substitutes: [],
    description: '桐乡情久，从全国大赛晋级的新生力量！'
  }
]

export const getTeamById = (id) => teamsDB.find(team => team.id === id)
export const getTeamByName = (name) => teamsDB.find(team => team.name === name || team.shortName === name)
export const getChampionTeam = () => teamsDB.find(team => team.isChampion)
export const getTeamsByGroup = () => {
  return teamsDB.reduce((groups, team) => {
    const group = team.group || '未分组'
    if (!groups[group]) groups[group] = []
    groups[group].push(team)
    return groups
  }, {})
}
export const getTopTeams = (count = 6) => [...teamsDB].sort((a, b) => a.springRank - b.springRank).slice(0, count)

export default teamsDB
